import React, { useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';

const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const [clickCount, setClickCount] = useState(0);

  const isLoggedIn = !!localStorage.getItem('auth_token');
  const userName = localStorage.getItem('auth_name') || '';

  React.useEffect(() => {
    if (clickCount >= 3) {
      setClickCount(0);
      navigate('/admin/login');
    }
    if (clickCount > 0 && clickCount < 3) {
      const timer = setTimeout(() => setClickCount(0), 1000);
      return () => clearTimeout(timer);
    }
  }, [clickCount, navigate]);

  const handleLogoClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setClickCount(prev => prev + 1);
  };

  const handleLogout = () => {
    localStorage.removeItem('auth_token');
    localStorage.removeItem('auth_name');
    localStorage.removeItem('auth_email');
    localStorage.removeItem('auth_username');
    navigate('/');
  };

  const isActive = (path) => location.pathname === path;

  return (
    <nav className="bg-[#D62828] text-white shadow-lg" data-testid="navbar">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          <div className="flex items-center gap-3 cursor-pointer select-none" onClick={handleLogoClick} data-testid="navbar-logo">
            <img src="/jit-logo.png" alt="JIT Logo" className="h-12 w-12 rounded-full object-cover bg-white" />
            <div className="flex flex-col">
              <span className="font-bold text-lg leading-tight">Just In Time "JIT" Cargo Express</span>
            </div>
          </div>

          {/* Desktop menu */}
          <div className="hidden md:flex items-center gap-6">
            <Link to="/" className={`text-sm font-medium transition-colors hover:text-yellow-300 ${isActive('/') ? 'text-yellow-300' : ''}`}>Home</Link>
            <Link to="/track" className={`text-sm font-medium transition-colors hover:text-yellow-300 ${isActive('/track') ? 'text-yellow-300' : ''}`}>Track Shipment</Link>
            <Link to="/history" className={`text-sm font-medium transition-colors hover:text-yellow-300 ${isActive('/history') ? 'text-yellow-300' : ''}`}>My Shipments</Link>
            {isLoggedIn ? (
              <div className="flex items-center gap-4">
                <span className="text-sm text-yellow-200">{userName}</span>
                <button onClick={handleLogout} className="text-sm font-medium bg-white/20 hover:bg-white/30 px-4 py-1.5 rounded-lg transition-colors" data-testid="logout-btn">Logout</button>
              </div>
            ) : (
              <div className="flex items-center gap-3">
                <Link to="/login" className="text-sm font-medium bg-white/20 hover:bg-white/30 px-4 py-1.5 rounded-lg transition-colors" data-testid="login-link">Login</Link>
                <Link to="/signup" className="text-sm font-medium bg-[#FDD935] hover:bg-[#F5D020] text-black px-4 py-1.5 rounded-lg transition-colors" data-testid="signup-link">Sign Up</Link>
              </div>
            )}
          </div>

          {/* Mobile menu toggle */}
          <button onClick={() => setMenuOpen(!menuOpen)} className="md:hidden p-2 hover:bg-white/10 rounded-lg" data-testid="mobile-menu-toggle">
            {menuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>

        {/* Mobile menu */}
        {menuOpen && (
          <div className="md:hidden pb-4 space-y-2" data-testid="mobile-menu">
            <Link to="/" className="block py-2 px-3 rounded hover:bg-white/10" onClick={() => setMenuOpen(false)}>Home</Link>
            <Link to="/track" className="block py-2 px-3 rounded hover:bg-white/10" onClick={() => setMenuOpen(false)}>Track Shipment</Link>
            <Link to="/history" className="block py-2 px-3 rounded hover:bg-white/10" onClick={() => setMenuOpen(false)}>My Shipments</Link>
            {isLoggedIn ? (
              <>
                <span className="block py-2 px-3 text-yellow-200">{userName}</span>
                <button onClick={() => { handleLogout(); setMenuOpen(false); }} className="block w-full text-left py-2 px-3 rounded hover:bg-white/10">Logout</button>
              </>
            ) : (
              <>
                <Link to="/login" className="block py-2 px-3 rounded hover:bg-white/10" onClick={() => setMenuOpen(false)}>Login</Link>
                <Link to="/signup" className="block py-2 px-3 rounded hover:bg-white/10" onClick={() => setMenuOpen(false)}>Sign Up</Link>
              </>
            )}
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;
